import { get } from 'lodash';

export const shouldEdit = (valuesByKey, key) => get(valuesByKey, [`Edit.${key}`, 'Value']) !== 'false';

export const shouldNotHide = (valuesByKey, key) => get(valuesByKey, [`Hide.${key}`, 'Value']) !== 'true';

export const shouldShow = (valuesByKey, key) => get(valuesByKey, [`Show.${key}`, 'Value']) === 'true';

export const shouldCreate = (valuesByKey, key) => get(valuesByKey, [`Create.${key}`, 'Value']) === 'true';

export const shouldUse = (valuesByKey, key) => get(valuesByKey, [`Use.${key}`, 'Value']) === 'true';



// WEBPACK FOOTER //
// ./src/utils/valuesByKey.js